import PageList from './List';
import PageForm from './Form';


export default {
    path: 'cadastros',
    redirect: '/cadastros/paginas',
    name: 'Cadastro Páginas',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'paginas',
            name: 'list-page',
            component: PageList,
            meta: {
                requiresAuth: true,
                label: 'Listar Páginas'
            }
        },
        {
            path: 'paginas/novo',
            name: 'new-page',
            component: PageForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Página'
            }
        },
        {
            path: 'paginas/:id',
            name: 'edit-page',
            component: PageForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Página'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/page/router.js